import { combineLatest } from 'rxjs';
import { Injectable } from '@angular/core';
import { gql, Apollo } from 'apollo-angular';
import { pluck } from 'rxjs/operators';
import { Filter } from 'src/app/core/models/filter';
const getSupplierAccountRequestsQuery = gql`query supplier_account_requests($limit:Int,$offset:Int){
  supplier_account_requests(order_by:{created_at: desc}, limit:$limit, offset: $offset){
    id
    created_at
    updated_at
    supplier_id
    name
    email
    phone
    supplier {
      id
      name
    }
  }
}`;

const getSupplierAccountRequestsAggregateQuery = gql`query supplier_account_requests_aggregate{
  supplier_account_requests_aggregate{
    aggregate{
      count
    }
  }
}`
@Injectable({
  providedIn: 'root'
})
export class GetSupplierAccountRequestsService {
  /* ------------------------------- Constructor ------------------------------ */
  constructor(private apollo: Apollo) { }
  /* -------------------------- Get Supplier Accounts ------------------------- */
  getSupplierAccountRequests(filter: Filter){
    return combineLatest([
      this.apollo.use('external').query({
        query: getSupplierAccountRequestsQuery,
        variables:{
          limit: filter.limit,
          offset: filter.offset
        }
      }).pipe(pluck('data', 'supplier_account_requests')),
      this.apollo.use('external').query({
        query: getSupplierAccountRequestsAggregateQuery
      }).pipe(pluck('data', 'supplier_account_requests_aggregate', 'aggregate', 'count'))
    ])
  }
}

